import { styled } from '@mui/material'
import { FC } from 'react'

const Title = styled('div')`
  font-size: 20px;
  color: #ffffff;
  line-height: 26px;
`

const Subtitle = styled('div')`
  font-family: var(--font-Apeiron);
  font-size: 16px;
  color: #c4c4c4;
  line-height: 16.5px;
  margin-left: 12px;
  align-self: flex-end;
`

const Container = styled('div')`
  display: flex;
  margin: 16px 0 4px 20px;
`

export const PlanetDetailSectionTitle: FC<Props> = props => {
  const { className, title, subTitle } = props

  return (
    <Container className={className}>
      <Title>{title}</Title>
      <Subtitle>{subTitle}</Subtitle>
    </Container>
  )
}

type Props = {
  className?: string
  subTitle: string
  title: string
}
